import { ColorX } from "IZOX/STATIC";

/**
 * @typedef {Object} receiptStatus
 * @property {import("IZOX/__typedef/common").lang} label
 * @property {String} color
 * @property {String} bgColor
 */

class ReceiptUtils {

  /**
   * @type {Object<string, receiptStatus>}
   */
  static __status = {
    Unpaid: {
      label: {
        EN: "Unpaid",
        TC: "未付款"
      },
      color: ColorX.CSS("Pending"),
      bgColor: ColorX.CSS("PendingBg")
    },
    Paid: {
      label: {
        EN: "Paid",
        TC: "已付款"
      },
      color: ColorX.CSS("Renewed"),
      bgColor: ColorX.CSS("RenewedBg")
    },
    Submitted: {
      label: {
        EN: "Waiting for approval",
        TC: "等待核准"
      },
      color: ColorX.CSS("Waiting"),
      bgColor: ColorX.CSS("WaitingBg")
    },
    Rejected: {
      label: {
        EN: "Rejected",
        TC: "已被拒"
      },
      color: ColorX.CSS("Pending"),
      bgColor: ColorX.CSS("PendingBg")
    }
  };

  /**
   * 
   * @param {status} status 
   * @returns {receiptStatus}
   */
  static GetStatus(status){
    return this.__status[status] ?? null;
  }

}

export default ReceiptUtils;